import OrderingOrdersService from "@/services/OrderingOrdersService";

const rejectApiError = (error) => Promise.reject(error.response?.data || error);

export const orderingOrders = {
  namespaced: true,
  actions: {
    getStores() {
      return OrderingOrdersService.GetStores().catch(rejectApiError);
    },
    getOrders(context, params) {
      return OrderingOrdersService.GetOrders(params).catch(rejectApiError);
    },
    getOrder(context, orderId) {
      return OrderingOrdersService.GetOrder(orderId).catch(rejectApiError);
    },
  },
};
